import { r as createLogger } from "../logger-CdXeOlrX.js";
//#region ../src/sensors/gps-error-handler.ts
/**
* GPS Error Handler
*
* Provides user-facing error messages for GPS failures.
* Separates error handling logic from GPS module for testability.
*/
const log = createLogger("GPSError");
/**
* GPS error codes from the Geolocation API.
* Duplicated here to avoid depending on browser types in tests.
*/
const GPS_ERROR_CODES = {
	PERMISSION_DENIED: 1,
	POSITION_UNAVAILABLE: 2,
	TIMEOUT: 3
};
/**
* User-friendly error messages for each GPS error type.
*/
const GPS_ERROR_MESSAGES = {
	[GPS_ERROR_CODES.PERMISSION_DENIED]: "GPS permission denied. Enable location access in your browser or device settings.",
	[GPS_ERROR_CODES.POSITION_UNAVAILABLE]: "GPS position unavailable. Move outdoors for better signal.",
	[GPS_ERROR_CODES.TIMEOUT]: "GPS timeout. Move outdoors or check that location services are enabled."
};
/**
* Default message for unknown error codes.
*/
const GPS_ERROR_MESSAGE_UNKNOWN = "GPS error. Check your device settings.";
/**
* Get a user-friendly error message for a GPS error.
*
* @param error - The GeolocationPositionError from the browser API
* @returns A user-friendly error message
*/
function getGpsErrorMessage(error) {
	return GPS_ERROR_MESSAGES[error.code] ?? "GPS error. Check your device settings.";
}
/**
* Create a GPS error handler that logs and shows user-facing errors.
*
* @param showError - Function to display error to user (e.g., from hud.ts)
* @returns A function suitable for use as startGpsWatch's onError callback
*/
function createGpsErrorHandler(showError) {
	return (error) => {
		log.error(`GPS error (code ${error.code}):`, error.message);
		showError(getGpsErrorMessage(error));
	};
}
//#endregion
export { GPS_ERROR_CODES, GPS_ERROR_MESSAGES, GPS_ERROR_MESSAGE_UNKNOWN, createGpsErrorHandler, getGpsErrorMessage };
